import { render } from "./NetworkersCard.vue?vue&type=template&id=55d0de1f&scoped=true"
import script from "./NetworkersCard.vue?vue&type=script&lang=js"
export * from "./NetworkersCard.vue?vue&type=script&lang=js"

import "./NetworkersCard.vue?vue&type=style&index=0&id=55d0de1f&scoped=true&lang=less"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d0de1f"]])

export default __exports__